import { forwardRef } from 'react';
import {
  FaIcon,
  ListItem,
  Resource,
  useMarkResourceAsRead,
} from '@fe-learner-common';
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { ListItemProps } from './ResourceListItem';
import { useConfigContext } from '@fe-core/context';

export const Link = forwardRef<
  HTMLAnchorElement,
  Omit<ListItemProps, 'onResourceClick' | 'container'>
>(({ resource, participationId, texts, ...rest }, ref) => {
  const { config } = useConfigContext();
  const { mutate: markAsRead } = useMarkResourceAsRead({
    resourceId: resource.rid,
    participationId,
  });
  const url =
    resource.link ||
    `${config.apiUrls.aleweb}/participation/${participationId}/resource/${resource.rid}/useDirect`;

  return (
    <ListItem
      role="article"
      className="flex items-center justify-between gap-x-4 overflow-hidden p-3"
      aria-label={texts.groupTypes[resource.groupType]}
    >
      <a
        ref={ref}
        className="l-btn l-btn-tertiary flex items-center justify-between gap-x-4 overflow-hidden p-3"
        onClick={() => {
          markAsRead();
        }}
        href={url}
        target={resource.useMode === 'newwindow' ? '_blank' : '_self'}
        rel="noreferrer"
        {...rest}
      >
        <Resource
          resourceId={resource.rid}
          title={resource.material.webTitle}
          groupType={resource.groupType}
          thumbnail={resource.material.thumbnail}
          tags={resource.tags}
          isNew={resource.newResource}
          texts={texts}
        />
        <FaIcon
          className="m-2 text-neutral-500 max-md:mb-auto"
          width={16}
          height={16}
          icon={
            resource.material.productType === 'genericfile'
              ? faDownload
              : faLink
          }
        />
      </a>
    </ListItem>
  );
});
Link.displayName = 'LinkListItem';
